import React from 'react'

import {FieldPickerType} from "../../../../../render/picker"

// const debug = "FieldSelectFields_PickerValueEmpty"
const debug = false

export default function FieldSelectFields_PickerValueEmpty(props:any) {

    debug && console.log(debug, 'render', props)

    switch (props.type) {
        case FieldPickerType.CIRCLE:
            return (
                <div className="ui5-circle-selector not-set" onClick={props.onClick}>
                    <div className={Classes("icon", props.field.icon)}/>
                    {props.children}
                </div>
            )

        case FieldPickerType.DEFAULT:
        default                     :
            const classes = Classes("ui5-field-picker is-empty", props.className)

            return (
                <div className={classes} onClick={props.onClick}>
                    <div className={Classes("icon", props.field.icon, props.options?.iconClass)}/>
                    {!!props.field.label && <div className="picker-label">{props.field.label}</div>}
                    {props.children}
                </div>
            )

    }
}
